import mongoose from "mongoose";
import { z } from "zod";

const isValidId = (id) => mongoose.Types.ObjectId.isValid(id);

export const ServiceValidationSchema = z.object({
  service_name: z
    .string()
    .min(1, { message: "Service name is required." })
    .transform((v) => v.trim()),
  slug: z
    .string()
    .min(1, { message: "Slug is required." })
    .trim()
    .transform(
      (slug) =>
        slug
          .toLowerCase()
          .replace(/[^a-z0-9\s-]/g, "") // Remove invalid characters
          .replace(/\s+/g, "-") // Replace spaces with hyphens
          .replace(/-+/g, "-") // Replace multiple hyphens with single hyphen
          .replace(/^-|-$/g, "") // Remove leading or trailing hyphens
    )
    .refine((slug) => /^[a-z0-9-]+$/.test(slug), {
      message:
        "Slug must contain only lowercase letters, numbers, and hyphens.",
    }),
  service_short_description: z
    .string()
    .default("")
    .transform((v) => v.trim()),
  featured_image: z
    .string()
    .nullable()
    .refine((v) => v === null || isValidId(v), {
      message: "Featured image must be a valid ObjectId or null.",
    }),
  banner_image: z
    .string()
    .nullable()
    .refine((v) => v === null || isValidId(v), {
      message: "Banner image must be a valid ObjectId or null.",
    }),
  service_description: z
    .string()
    .default("")
    .transform((v) => v.trim()),
  source_link: z
    .string()
    .default("")
    .transform((v) => v.trim())
    .refine((v) => v === "" || /^https:\/\/.+$/.test(v), {
      message: "Source link must be a valid HTTPS URL",
    }),
  button_label: z
    .string()
    .default("")
    .transform((v) => v.trim()),
  order_number: z
    .string()
    .transform((val) => val.trim() || "1")
    .refine((val) => !isNaN(Number(val)) && Number.isInteger(Number(val)), {
      message: "Order number must be a valid number",
    })
    .refine((val) => Number(val) > 0, {
      message: "Order number must be greater than 0",
    }),

  service_info_title: z
    .string()
    .default("")
    .transform((v) => v.trim()),
  service_info_sub_title: z
    .string()
    .default("")
    .transform((v) => v.trim()),

  service_form_heading: z
    .string()
    .default("")
    .transform((v) => v.trim()),
  service_form_description: z
    .string()
    .default("")
    .transform((v) => v.trim()),
  service_form_button_label: z
    .string()
    .default("")
    .transform((v) => v.trim()),

  service_registration_resources_heading: z
    .string()
    .default("")
    .transform((v) => v.trim()),
  service_registration_resources_button_label: z
    .string()
    .default("")
    .transform((v) => v.trim()),

  service_download_resources_heading: z
    .string()
    .default("")
    .transform((v) => v.trim()),
  service_download_resources_button_label: z
    .string()
    .default("")
    .transform((v) => v.trim()),

  meta_title: z
    .string()
    .default("")
    .transform((v) => v.trim()),

  meta_image: z
    .string()
    .nullable()
    .refine((value) => value === null || isValidId(value), {
      message: "Meta Image must be a valid ObjectId or null.",
    })
    .default(null),

  meta_keywords: z
    .string()
    .default("")
    .transform((v) => v.trim()),

  meta_description: z
    .string()
    .default("")
    .transform((v) => v.trim()),
});
